function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  cursor: ", ";\n  transition: background-color 0.3s;\n\n  &:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "../../../../theme";
export var BodyWrapper = styled.tbody(_templateObject());
export var BodyRow = styled.tr(_templateObject2(), function (props) {
  return props.onClick ? 'pointer' : 'default';
}, function (props) {
  return props.theme.variables.colors.lightGrey;
});